const axios = require("axios");
var tmpHost = location.hostname;
let url = 'https://dappweb-api.huolala.cn/index.php?_m=driver&_a=get_user_info'
if (/-stg|-dev|localhost|^192|^172/.test(tmpHost)) {
  url = 'https://dappweb-api-stg.huolala.cn/index.php?_m=driver&_a=get_user_info'
}
const sjUserData = (token) => {
  return new Promise((resolve, reject) => {
    axios.get(`${url}&token=${token}`)
      .then(function (response) {
        if (response.data.ret === 0) {
          let data = {
            nickName: response.data.data.nickname,
            phone: response.data.data.phone_no,
            driverId: response.data.data.driver_id || ''
          }
          resolve(data)
        } else {
          resolve(response)
        }
      })
      .catch(function (error) {
        resolve(error)
      })
  })
}
const appDriverData = async function (token) {
  let data = {}
  let driverData = await sjUserData(token)
  if (driverData.nickName) Object.assign(data, driverData)
  return data;
}
export default appDriverData
